import new_player_fetch from "@/components/new-player/modules/new_player_fetch";
import new_player_attribute from "@/components/new-player/modules/new_player_attribute";

export default(context) => {

    let cache = context.$store.getters['cache_videos/cache_videos']

    for(let i = 0; i < context.videos.length; i++) {
        let file = context.videos[i].video || context.videos[i].webm
        let is_has = false
        for(let k = 0; k < cache.length; k++) {
            if(file === cache[k].url) {
                is_has = true
               if(!context.videos[i].blob) {
                   context.videos[i].blob = cache[k].blob
               }
            }
        }

        if(!is_has) {
            new_player_fetch(context, file)
            break;
        }

        if(i === context.videos.length - 1) {
            new_player_attribute(context)
        }
    }
}